import React, { Component } from "react";
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import NovedadesHelper from '../../../../../Common/Helpers/NovedadesHelper';
import VigenciaDias from "./VigenciaDias";

class EsTarjetaTemporal extends Component {
    constructor(props) {
        super(props)

        this.state = { esVigenciaDias: false }
    }

    /**
     * 
     */
    render() {
        const { props, state } = this;
        const { data, tarjeta } = props;

        let esTemporal = "Es una tarjeta temporal";
        let esTemporalNovedad = NovedadesHelper.CheckConNovedadPorCampos(this.props.codigoNovedad,
            tarjeta.EsTarjetaTemporal,
            data.novedadesTarjetaDatos,
            data.esNovedadEditada,
            esTemporal,
            [{ Clave: "TarjetaCreditoId", Valor: tarjeta.TarjetaCreditoId }]);

        return (
            <div className="col-xs-12" >
                <div>
                    <label className="label-secondary">{esTemporalNovedad.descripcion}</label>
                </div>
                <div className="col-xs-12" >
                    {(state.esVigenciaDias || esTemporalNovedad.check) &&
                        <VigenciaDias data={data}
                            tarjeta={tarjeta}
                            codigoNovedad="VIGER_TARJ"
                            getDiasVigencia={this.props.getDiasVigencia}
                        />
                    }
                </div>
            </div>
        )
    }
}
export default EsTarjetaTemporal;